export default function SelectPlaceValidations(values: any) {
  let errors: any = {};

  if (!values.street) {
    errors.street = 'El nombre de la calle es requerido';
  }

  if (!values.street_number) {
    errors.street_number = 'El número de la calle es requerido';
  }

  if (!values.locality) {
    errors.locality = 'La localidad es requerida';
  }

  if (!values.province) {
    errors.province = 'La provincia es requerida';
  }

  return errors;
}
